/**
 * The measured outcome of an adoption as one line, or null when nothing was measured.
 *
 * A module of its own rather than an export from AdoptionsPage, because both sides of the wall
 * need it: the advisor's cabinet screen and the public result card. Importing it from the page
 * meant the public bundle pulled in an authenticated screen — and, worse, that page's stylesheet
 * import was the only thing putting the public block's own CSS on the page, so lazy-loading the
 * cabinet would have silently unstyled a public component.
 */
export function indicatorLine(name: string | null, value: string | null): string | null {
  if (!name) return null;
  // No trailing colon when there is no figure: "Sporul de recoltă:" reads as a value that failed
  // to load, rather than as an indicator somebody is still watching.
  return value ? `${name}: ${value}` : name;
}
